import React from "react";
import { Switch, Route } from "react-router-dom";
import Dashboard from "../pages/dashboard";

const DefaultRouter = () => {
  return (
    <Switch>
      <Route exact path="/dashboard" component={Dashboard} />
    </Switch>
  );
};

export default DefaultRouter;
